import Vue from 'vue'
import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const saveRegroupement = async regroupement => {
    const verb = regroupement.id === null ? 'post' : 'put'
    const dbRegroupement = await axios[verb]('/service/regroupement', regroupement)
        .catch((e) => {
            throw new CustomException(e, 'Error saving regroupement')
        })
    Vue.toasted.show('Regroupement enregistré').goAway(1500)
    return dbRegroupement.data
}

export const deleteRegroupement = async id => {
    const dbRegroupement = await axios.delete(`/service/regroupement/${id}`)
        .catch((e) => {
            throw new CustomException(e, 'Error saving regroupement')
        })
    Vue.toasted.show('Regroupement supprimé').goAway(1500)
    return dbRegroupement.data
}

export const getRegroupements = async params => {
    const regroupements = await axios.get('/service/regroupements', { params })
        .catch((e) => {
            throw new CustomException(e, 'Error getting regroupements')
        })
    return regroupements.data
}
